import { MessageDialogProps } from "designSystem/components/dialog/MessageDialog";
import { MessageDialog } from "designSystem/index";
import locale from "csi/locale";
import React, { FunctionComponent } from "react";
import SetEditStore from "./store/SetEditStore";

interface SetEditErrorDialogProps extends Partial<MessageDialogProps> {
	/** store for editing set */
	editSetStore: SetEditStore;
}

const SetEditErrorDialog: FunctionComponent<SetEditErrorDialogProps> = (props) => {
	const { editSetStore, ...otherProps } = props;

	return (
		<MessageDialog
			category="warn"
			messageRes="PresentationMasonryImageFailMessage"
			messageResParams={[locale.getNodeConfiguredName(editSetStore.ppSet, editSetStore.cache)]}
			open
			titleRes="PresentationMasonryImageFailTitle"
			{...otherProps}
		/>
	);
};

export default SetEditErrorDialog;
